import { useState } from "react";
//import { useDispatch, useSelector } from "react-redux";
//import { setLoadingTicket } from "../slice/loadingSlice";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { toast } from "react-toastify";

const useTicket = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    //const dispatch = useDispatch();

    const host = process.env.REACT_APP_API_URL;
    const objUser = JSON.parse(sessionStorage.getItem("user"));
    const ticketToken = JSON.parse(sessionStorage.getItem("ticket_user"));
    var decoded = jwt_decode(objUser.token);

    const token = objUser.token;

    const cf = decoded.CFA;
    const HOST = process.env.REACT_APP_API_URL;

        const getTicketList = (params, onSuccess, onError) => {
        setLoading(true);
        const configHeaders = {
            headers: {
                Authorization: "Bearer " + token,
                cf: cf,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                "Authorization-Manage-Project":" Bearer " + ticketToken.token,
            },
            
        };
        try {
            axios
            .get(`${HOST}/api/v1/manage/tickets/list?from=${params.startDate}&to=${params.endDate}&state=${params.state}`,
                
                
                // {
                // from: params.startDate,
                // to: params.endDate,
                // state: params.state
                // },
                
                configHeaders
                
                // params,
                // configHeaders
            
                
                
                
            )
            .then(
                function (result) {
                    if(result.status === 200) {
                        onSuccess(result.data);
                    } else if(result.status === 401){
                        onError();
                        //logOut();
                    } else if (result.status === 504){
                        toast.error("Errore nel recupero dati")
                    }
                     else {
                        onError();
                    }
                },
                function (error) {
                    /*if(error.response.status === 401){
                        onError()
                        //logOut();
                    } else {*/
                        onError();
                    //}
                }
            ).finally(()=>setLoading(false));
        } catch (error) {
            console.log(`Error Configuration API`)
            toast.error("Errore Imprevisto")
        }
    }

    const createTicket = (ticketInfo, onSuccess, onError) => {
        setLoading(true);
        const configHeaders = {
            headers: {
                Authorization: "Bearer " + token,
                CF: cf,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                "Authorization-Manage-Project":" Bearer " + ticketToken.token,
            },
        };
        try {
            axios
            .post(`${HOST}/api/v1/manage/tickets/create`,
                ticketInfo,
                configHeaders
            )
            .then(
                function (result) {
                    if(result.status === 200) {
                        onSuccess(result.data);
                    } else if(result.status === 401){
                        onError();
                        //logOut();
                    } else {
                        onError();
                    }
                },
                function (error) {
                    /*if(error.response.status === 401){
                        onError()
                        //logOut();
                    } else {*/
                        onError();
                    //} 
                }
            ).finally(()=>setLoading(false));
        } catch (error) {
            console.log(`Error Configuration API`)
            toast.error("Errore Imprevisto")
        }
    }

    const getTicketDetail = (idTicket,onSuccess, onError) => {
        setLoading(true);
        const configHeaders = {
            headers: {
                Authorization: "Bearer " + token,
                CF: cf,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                "Authorization-Manage-Project":" Bearer " + ticketToken.token,
            },
        };
        try {
            axios
            .get(`${HOST}/api/v1/manage/tickets/details/${idTicket}`,
                configHeaders,
            )
            .then(
                function (result) {
                    if(result.status === 200) {
                        onSuccess(result.data);
                    } else if(result.status === 401){
                        onError();
                        //logOut();
                    } else {
                        onError();
                    }
                },
                function (error) {
                    /*if(error.response.status === 401){
                        onError()
                        //logOut();
                    } else {*/
                        onError();
                    //}
                }
            ).finally(()=>setLoading(false));
        } catch (error) {
            console.log(`Error Configuration API`)
            toast.error("Errore Imprevisto")
        }
    }

    const saveAttachment = (idTicket, file, onSuccess, onError) => {
        setLoading(true);
        const configHeaders = {
            headers: {
                Authorization: "Bearer " + token,
                CF: cf,
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                "Authorization-Manage-Project":" Bearer " + ticketToken.token,
            },
        };
        try {
            let form = new FormData();
            form.append("file",file);
            // console.log("file nell'hook" , file);
            // console.log("dati prima dell'invio",form);
              for (const [key, value] of form.entries()) {

                if(key == "file") console.log(key, value); // value sarà un File per il campo "file"

  }
 
            axios
            .post(`${HOST}/api/v1/manage/tickets/upload/file/${idTicket}`,
                form,
                configHeaders,
            )
            .then(
                function (result) {
                    if(result.status === 200) {
                        onSuccess(result.data);
                    } else if(result.status === 401){
                        onError();
                        //logOut();
                    } else {
                        onError();
                    }
                },
                function (error) {
                    /*if(error.response.status === 401){
                        onError()
                        //logOut();
                    } else {*/
                        onError();
                    //}
                }
            ).finally(()=>setLoading(false));
        } catch (error) {
            console.log(`Error Configuration API`)
            toast.error("Errore Imprevisto")
        }
    }
    // //-- IGNORE --- API per gli allegati dei ticket presente dentro dettaglio ticket
    // const getAttchment = (idTicket,onSuccess, onError) => {
    //     dispatch(setLoadingTicket(true));
    //     const configHeaders = {
    //         headers: {
    //             Authorization: "Bearer " + token,
    //             CF: cf,
    //             "Content-Type": "application/json",
    //             "Access-Control-Allow-Origin": "*",
    //             "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
    //             "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    //         },
    //     };
    //     try {
    //         axios
    //         .get(`${HOST}/api/v1/manage/tickets/attachment/${idTicket}`,
    //             configHeaders,
    //         )
    //         .then(
    //             function (result) {
    //                 if(result.status === 200) {
    //                     onSuccess(result.data);
    //                 } else if(result.status === 401){
    //                     onError();
    //                     //logOut();
    //                 } else {
    //                     onError();
    //                 }
    //             },
    //             function (error) {
    //                 /*if(error.response.status === 401){
    //                     onError()
    //                     //logOut();
    //                 } else {*/
    //                     onError();
    //                 //}
    //             }
    //         ).finally(()=>dispatch(setLoadingTicket(false)));
    //     } catch (error) {
    //         console.log(`Error Configuration API`)
    //         toast.error("Errore Imprevisto")
    //     }
    // }

    const downloadAttachment = (idFile, onSuccess, onError) => {

        setLoading(true);
        const configHeaders = {
            headers: {
                Authorization: "Bearer " + token,
                CF: cf,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                "Authorization-Manage-Project":" Bearer " + ticketToken.token,
            },
        };
        try{
            axios 
            .get(`${HOST}/api/v1/manage/tickets/download/file/${idFile}`,
                configHeaders,
            )
            .then(
                function (result) {
                    if(result.status === 200) {
                        onSuccess(result.data);
                    }else if(result.status === 401){
                        onError();
                    } else {
                        onError();
                    }
                },
                function (error) {
                    onError()
                }
            ).finally(() => setLoading(false));
        } catch (error) {
            console.log('Errore nel download degli allegati')
            toast.error('Errore imprevisto')
        }
    
    }
    // //ignora api già presente sopra save attachment
    // const uploadAttachment = (idTicket, file, onSuccess, onError) => {

    //     dispatch(setLoadingTicket(true));
    //     const configHeaders = {
    //         headers: {
    //             Authorization: "Bearer " + token,
    //             CF: cf,
    //             "Content-Type": "application/json",
    //             "Access-Control-Allow-Origin": "*",
    //             "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
    //             "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    //         },
    //     };
    //     try{
    //         axios
    //         .post(`${HOST}/api/v1/manage/tickets/upload/file/${idTicket}`,
    //             file,
    //             configHeaders,

    //         ).then(
    //             function (result) {
    //                 if(result.status === 200) {
    //                     onSuccess(result.data);
    //                 }else if(result.status === 401){
    //                     onError();
    //                 } else {
    //                     onError();
    //                 }
    //             },
    //             function (error) {
    //                 onError()
    //             }
    //         ).finally(() => dispatch(setLoadingTicket(false)));
    //     } catch (error) {
    //         console.log('Errore nel download degli allegati')
    //         toast.error('Errore imprevisto')
    //     }
        
    // }

        const updateTicketComment = (ticketComment, onSuccess, onError) => {
        setLoading(true)
        const configHeaders = {
            headers: {
                Authorization: "Bearer " + token,
                CF: cf, 
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                "Authorization-Manage-Project":" Bearer " + ticketToken.token,
            },
        };
        try {
            axios
            .post(`${HOST}/api/v1/manage/tickets/add/comment`,
                ticketComment,
                configHeaders
            )
            .then(
                function (result) {
                    if(result.status === 200) {
                        onSuccess(result.data);
                    } else if(result.status === 401){
                        onError();
                        //logOut();
                    } else {
                        onError();
                    }
                },
                function (error) {
                    if(error.response.status === 401){
                        onError()
                        //logOut();
                    } else {
                        onError();
                    }
                } 
            ).finally(()=>setLoading(false));
        } catch (error) {
            console.log(`Error Ticket API`)
            toast.error("Errore Imprevisto")
        }
    }

    return {getTicketList, createTicket, getTicketDetail, saveAttachment, downloadAttachment, updateTicketComment, loadingTicket:loading};
}
export default useTicket;